import type {ReactElement} from 'react';
import React from 'react';
import {BaseCustomShadowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-custom-shadow-color-panel';
import {RGBA, rgbaToHexString} from '@Utils/color.util';
import {colorToRgbaArray} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromShadowOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveSlideItem';

export function SlideitemCustomShadowColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const activeSlideItem = activeSlideUID && activeItem?.isSlideshow() ? activeItem.getSelectedSlide() : null;
  const dropShadowColor = useGetKeyFromShadowOfActiveSlideItem('color');

  if (!activeItem?.isSlideshow()) {
    throw new Error(`Expected slideshow item but got ${activeItem?.gitype}`);
  }

  if (!activeSlideUID || !activeSlideItem) {
    throw new Error('unable to get the selected active slide');
  }

  if (!dropShadowColor) {
    throw new Error('unable to get the dropshadow color property of selected active slide');
  }

  const updateCustomShadow = (dropShadowColor: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        shadow: {
          ...activeSlideItem.toObject().shadow,
          color: rgbaToHexString(dropShadowColor),
        },
      },
      {
        undoable,
      }
    );
  };
  return <BaseCustomShadowColorPanel dropShadowColor={colorToRgbaArray(dropShadowColor)} onUpdateColor={updateCustomShadow} />;
}
